import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Gate for the main app — requires a normal role-bearing JWT.
 *
 * Routing:
 *   - still loading initial state → render nothing (avoids flash)
 *   - no token                    → /signin
 *   - scope=password_change       → /change-password (force rotation)
 *   - role-bearing token          → render Outlet
 */
export function ProtectedRoute() {
  const { token, decoded, initializing } = useAuth();
  const location = useLocation();

  if (initializing) return null;
  if (!token || !decoded) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }
  if (decoded.scope === "password_change") {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}
